import React, {useEffect, useRef, useState} from 'react';
import {
    addSize,
    checkNull,
    checkNullArr,
    checkNullStr,
    convertReadableSizeToBytes,
    divSize,
    getDefStr,
    getStrInitials,
    isBoolTrue,
    multSize,
    printError,
    subtractSize,
    vhToPx
} from "../utils/ReactUtils";
import {Button, CircleLoading, Dialog, Flexbox, Label} from "../index";
import PropTypes from "prop-types";
import {Constants, RippleVarVariant, THEME} from "../config/FusionConfig";

/**
 * Create an Avatar with initials-label, edit & preview features.
 *
 * @example
 * const [avatarImg, setAvatarImg] = useState();
 *
 * <Avatar
 *      wrapperClassName={''}
 *      className={''}
 *      labelClassName={''}
 *      justifyAt={'center'}
 *      alignAt={'start'}
 *      wrap={'wrap'}
 *      direction={'column'}
 *      label={'Avatar'}
 *      labelColor={'black'}
 *      accept={'.jpg, .jpeg, .png'}
 *      editTooltip={`Edit (.jpg, .jpeg, .png)`}
 *      showEdit={true}
 *      showDelete={true}
 *      circular={false}
 *      showFullPreviewDialog={true}
 *      disableImgDrag={true}
 *      editSize={'21px'}
 *      size={'100px'}
 *      maxSize={'10mb' or '5kb'}
 *      defAvatarImg={'https://cdn.pixabay.com/photo/2023/10/16/22/44/people-8320174_1280.png'}
 *      onChange={(e, file, fileObj, name) => {
 *          console.log('Avatar.webexImage.onChange.name:', name);
 *          setAvatarImg(file);
 *      }}
 *      onInvalidFormat={(e, name) => {
 *          console.error(`Invalid file format. File must be jpg or jpeg or png`);
 *      }}
 *      onSizeExceeded={(e, fileObj, fileSizeBytes) => {
 *          console.error(`Maz size exceeded: 10mb`);
 *      }}>{avatarImg}</Avatar>
 */
const Avatar = ({
                    className = "",
                    wrapperClassName = "",
                    labelClassName = "",
                    innerWrapperClassName = "",
                    editClassName = "",
                    deleteClassName = "",
                    imgClassName = "",
                    editBg = "",
                    labelAt = "start",
                    justifyAt = "center",
                    alignAt = "center",
                    wrap,
                    direction,
                    id,
                    width,
                    height,
                    size = "55px",
                    editSize,
                    onImageClick,
                    onEditClick,
                    onDeleteClick,
                    onImageHover,
                    onImageMouseLeave,
                    onError,
                    previewBorder = true,
                    previewBorderVariant = 'gray',
                    changeObjectFitOnHover = false,
                    hoverObjectFit = 'fill',
                    children,
                    label,
                    required,
                    component,
                    componentStart,
                    hidden,
                    labelFontSize = '12px',
                    hideErrImg,
                    labelTextWrap = false,
                    bordered = false,
                    circular = true,
                    showEdit = false,
                    showDelete = false,
                    variant = THEME,
                    showInitials = false,
                    showLoading = false,
                    disableImgDrag = false,
                    nameForInitials = '',
                    objectFit = 'cover',
                    roundedVariant = 3,
                    previewObjectFit = 'contain',
                    overflow = 'hidden',

                    editTooltip = "Edit Image",
                    deleteTooltip = "Remove Image",
                    accept,
                    labelColor = '',
                    onObjectFitChange,
                    showObjectFitChangeControl = false,
                    showFullPreviewDialog = false,
                    onFullPreview,
                    onFullPreviewDialogOpen,
                    onFullPreviewDialogClose,
                    previewTitle = 'Preview',
                    previewDialogWidthClass = 'col-sm-10 col-md-8',

                    //Style
                    style = {},
                    wrapperStyle = {},
                    labelStyle = {},
                    objectFitControlStyle = {},
                    editStyle = {},
                    deleteStyle = {},
                    imgStyle = {},
                    dottedExt = true,
                    onChange,
                    onSizeExceeded,
                    onInvalidFormat,
                    onFileLoading,
                    maxSize,//5mb, 5kb, 1kb
                    defAvatarImg = Constants.userVector,
                    capture,//?: boolean | 'user' | 'environment' | undefined
                    ...rest
                }) => {

    const TAG = "Avatar";
    const [defAvatar, setDefAvatar] = useState(getDefStr(defAvatarImg, Constants.userVector));

    const [showLoader, setShowLoader] = useState(false);

    const [avatarImg, setAvatarImg] = useState("");
    const [errorOccurred, setErrorOccurred] = useState(false);
    const [ofType, setOfType] = useState("");
    const [disableDrag, setDisableDrag] = useState(disableImgDrag);
    const [showNameInitials, setShowNameInitials] = useState(showInitials);
    const imgChooserInputRef = useRef(null);
    const [openPreviewDialog, setOpenPreviewDialog] = useState(false);

    useEffect(() => {
        setAvatarImg(children);
        // printLog(TAG, "children:", children);
        if (!checkNullStr(children)) {
            setDisableDrag(true);
        }
    }, [children]);
    useEffect(() => {
        setDefAvatar(defAvatarImg);
    }, [defAvatarImg]);
    useEffect(() => {
        setOfType(objectFit);
    }, [objectFit]);
    useEffect(() => {
        setShowNameInitials(isBoolTrue(showInitials));
    }, [showInitials]);
    useEffect(() => {
        // setDisableDrag(isBoolTrue(disableImgDrag));
    }, [disableImgDrag]);
    useEffect(() => {
        setShowLoader(isBoolTrue(showLoading));
    }, [showLoading]);

    return (<>
        {(!isBoolTrue(hidden) && (!isBoolTrue(hideErrImg) || (isBoolTrue(hideErrImg) && !errorOccurred)))
            && <div className={`m-0 p-0 ${wrapperClassName} d-flexx 
         ${!(wrapperClassName + '').includes('d-') ? 'd-flex' : ''}
         jc-${justifyAt} al-${alignAt} flex-${wrap} fd-${direction}`}
                    style={{
                        // height: getDefStr(height, size),
                        ...wrapperStyle
                    }}>

                {/*<div className={'w-100 m-0 p-0'}>*/}
                {checkNullStr(label)
                    && <Label className={`fw-bold w-100x m-0 p-0 px-1 text-input-label ${labelClassName} ${isBoolTrue(labelTextWrap) ? 'text-wrap' : 'text-nowrap'}`}
                              widthClass={labelClassName}
                              style={labelStyle}
                              color={labelColor}
                              fontSize={labelFontSize}
                              required={required}
                              textAt={labelAt}>{label}</Label>}
                <Flexbox
                    className={`avatar-wrapper w-autox ${innerWrapperClassName}`} position={'relative'}
                    id={id}>
                    <div className={`p-0 m-0 bg-infox d-flex jc-center position-relative 
                ${className} ${(className + '').includes('w-') ? '' : 'w-auto'}
                ${(canShowPreviewDialog() && !errorOccurred) ? `cursor-pointer ${isBoolTrue(circular) ? 'circular' : `rounded-${roundedVariant}`} ${isBoolTrue(previewBorder) ? `border-1-5 border-solid' +
                    ' border-${previewBorderVariant}` : ''} transition-sm border-${variant}-hover` : ''}
                `}
                         style={{
                             height: addSize(getDefStr(height, size), 2.5), ...style
                         }}>
                        {(!showLoader && componentStart) && componentStart}


                        {(!showLoader && ((!checkNullStr(avatarImg, true) && !showNameInitials) || checkNullStr(avatarImg))) ?
                            // {(!showLoader && ((!checkNullStr(avatarImg, true) && !showNameInitials) || (checkNullStr(avatarImg) || (errorOccurred && checkNullStr(defAvatar))))) ?
                            <img
                                // src={avatarImg}
                                src={getDefStr(avatarImg, defAvatar)}
                                className={`avatar object-fit-${checkNullStr(avatarImg) ? ofType : 'cover'} 
                            ${isBoolTrue(circular) ? 'circular' : `rounded-${roundedVariant}`}
                            ${isBoolTrue(bordered) ? ` border-1 border-${variant} border-solid` : ''} ${imgClassName}`}
                                alt={'Preview'}
                                width={getDefStr(width, size)}
                                height={getDefStr(height, size)}
                                style={{...imgStyle}}
                                onClick={(e) => {
                                    if (canShowPreviewDialog()) setOpenPreviewDialog(true);
                                    if (onImageClick) onImageClick(e);
                                }}
                                onMouseEnter={() => {
                                    if (isBoolTrue(changeObjectFitOnHover)) setOfType(hoverObjectFit);
                                    if (onImageHover) onImageHover(ofType);
                                }}
                                onMouseLeave={() => {
                                    if (isBoolTrue(changeObjectFitOnHover)) setOfType(objectFit);
                                    if (onImageMouseLeave) onImageMouseLeave(ofType);
                                }}
                                onError={() => {
                                    if (checkNullStr(nameForInitials)) {
                                        setAvatarImg(null);
                                    } else {
                                        setAvatarImg(defAvatarImg);
                                    }
                                    setShowNameInitials(true);
                                    setDisableDrag(true);
                                    setErrorOccurred(true);
                                    if (onError) onError();
                                }}

                                onDrag={(e) => (disableDrag || isBoolTrue(disableImgDrag) || errorOccurred) && e.preventDefault()}
                                onContextMenu={(e) => (disableDrag || isBoolTrue(disableImgDrag) || errorOccurred) && e.preventDefault()}
                                onDrop={(e) => (disableDrag || isBoolTrue(disableImgDrag) || errorOccurred) && e.preventDefault()}
                                onDragEnter={(e) => (disableDrag || isBoolTrue(disableImgDrag) || errorOccurred) && e.preventDefault()}
                                onDragOver={(e) => (disableDrag || isBoolTrue(disableImgDrag) || errorOccurred) && e.preventDefault()}
                                onDragCapture={(e) => (disableDrag || isBoolTrue(disableImgDrag) || errorOccurred) && e.preventDefault()}
                                onDragEnterCapture={(e) => (disableDrag || isBoolTrue(disableImgDrag) || errorOccurred) && e.preventDefault()}
                                onDragStart={(e) => (disableDrag || isBoolTrue(disableImgDrag) || errorOccurred) && e.preventDefault()}

                                {...rest}
                            /> : (!showLoader && checkNullStr(nameForInitials) && isBoolTrue(showInitials)) && <label
                            className={`text-white bg-gray-dark rounded-5x d-flex jc-center al-center select-none 
                            text-capitalize m-0 p-2 ${imgClassName} ${isBoolTrue(circular) ? 'circular' : `rounded-${roundedVariant}`}`}
                            style={{
                                fontSize: divSize(size, 2),
                                width: size,
                                height: size,
                                // color: 'var(--textColor)',
                            }}
                            onClick={(e) => {
                                if (onImageClick) onImageClick(e);
                            }}>
                            {/*{removeNameHonorific(nameForInitials).split(' ')[0].split('')[0] + removeNameHonorific(nameForInitials).split(' ')[1].split('')[0]}*/}
                            {getStrInitials(nameForInitials, ' ', 2, true)}
                        </label>}

                        {/*loader*/}
                        {showLoader && <CircleLoading wrapperClassName={'position-absolutex w-100 p-2'}
                            // wrapperHeight={height}
                            // wrapperStyle={{transform: 'translate(16%) !important'}}
                            // wrapperStyle={{top: `-${divSize(size, 8.5)}`, left: '0px'}}
                            //                          wrapperStyle={{left: ".7rem", top: ".65remx"}}
                                                      size={subtractSize(size, 16)}/>}

                        {/*edit button*/}
                        {isBoolTrue(showEdit) && !showLoader && <Button
                            className={`m-0x mx-1 p-2 bg-${editBg} 
                    ${(isBoolTrue(bordered) || !isBoolTrue(bordered)) ? ` border-1 border-${variant} border-solid` : ''} 
                    position-absolute ${editClassName}`}
                            style={{top: `-${divSize(size, 8)}`, right: `-${divSize(size, 6)}`, ...editStyle}}
                            // style={{top: "-.5rem", right: "-.5rem", ...editStyle}}
                            iconClass={`bi bi-pencil text-${variant}`}
                            tooltip={editTooltip}
                            circular={true}
                            // width={divSize(size, 2.5)}
                            // height={divSize(size, 2.5)}
                            // fontSize={divSize(size, 5)}
                            width={getDefStr(editSize, divSize(size, 2.5))}
                            height={getDefStr(editSize, divSize(size, 2.5))}
                            fontSize={checkNullStr(editSize) ? divSize(editSize, 2) : divSize(size, 5)}
                            // highlightVariant={variant}
                            rippleColor={RippleVarVariant[variant]}
                            // fontSize={'12px'}
                            variant={'t'}
                            onClick={(e) => {
                                try {
                                    imgChooserInputRef.current.click();
                                    if (onEditClick) onEditClick(e);
                                } catch (e) {
                                    printError(TAG, e);
                                }
                            }}
                        />}

                        {isBoolTrue(showObjectFitChangeControl) && !showLoader && <Button
                            className={`m-0x mx-1 p-2 bg-${editBg} border-1  border-solid
                    ${(isBoolTrue(bordered)) ? `border-${variant}` : 'border-t'} 
                    position-absolute ${editClassName}`}
                            style={{
                                top: isBoolTrue(showEdit) ? `${divSize(size, 2)}` : '2px', right: '-2px', ...objectFitControlStyle
                            }}
                            iconClass={`bi bi-arrows-fullscreen text-${variant}`}
                            tooltip={editTooltip}
                            circular={true}
                            width={getDefStr(editSize, divSize(size, 2.5))}
                            height={getDefStr(editSize, divSize(size, 2.5))}
                            fontSize={checkNullStr(editSize) ? divSize(editSize, 2.3) : divSize(size, 5)}
                            // highlightVariant={variant}
                            rippleColor={RippleVarVariant[variant]}
                            // fontSize={'12px'}
                            variant={'t'}
                            onClick={() => {
                                try {
                                } catch (e) {
                                    printError(TAG, e);
                                }
                            }}
                        />}

                        {(!showLoader) && <div>
                            {component}
                            {/*delete img*/}
                            {(isBoolTrue(showDelete) && checkNullStr(avatarImg) && checkNullStr(children)) && <Button
                                className={`m-0x mx-1 p-2 ${(isBoolTrue(bordered) || !isBoolTrue(bordered)) ? ` border-1 border-danger border-solid` : ''} position-absolute ${deleteClassName}`}
                                style={{
                                    top: isBoolTrue(showEdit) ? multSize(editSize, 1.2) : `-${divSize(size, 8)}`,
                                    right: `-${divSize(size, 6)}`, ...deleteStyle
                                }}
                                iconClass={`bi bi-trash text-danger`}
                                tooltip={deleteTooltip}
                                circular={true}
                                width={getDefStr(editSize, divSize(size, 2.5))}
                                height={getDefStr(editSize, divSize(size, 2.5))}
                                fontSize={checkNullStr(editSize) ? divSize(editSize, 2) : divSize(size, 5)}
                                rippleColor={RippleVarVariant.danger}
                                // variant={CssVariant.danger}
                                outlined={true}
                                onClick={(e) => {
                                    children = null;
                                    setAvatarImg(null);
                                    setShowNameInitials(false);
                                    setDisableDrag(true);
                                    if (onDeleteClick) onDeleteClick();
                                }}
                            />}
                        </div>}
                        {<input style={{}}
                                className={'d-none'}
                                ref={imgChooserInputRef}
                                type="file"
                                accept={getDefStr(accept, "image/*")}
                                capture={capture}
                                onChange={(e) => {
                                    try {
                                        const fileObj = e.target.files[0];
                                        const name = fileObj.name;
                                        let fileExtension = (name + '').split('.').pop();
                                        fileExtension = ((isBoolTrue(dottedExt) ? ('.' + fileExtension) : fileExtension) + '').toLowerCase().trim();
                                        const fileSizeBytes = fileObj.size;
                                        // console.log('onChange.name:', name, 'fileSizeBytes:', fileSizeBytes, 'maxSize:', convertReadableSizeToBytes(maxSize));
                                        if (checkNull(fileObj)) {
                                            if (checkNullStr(maxSize) && fileSizeBytes > convertReadableSizeToBytes(maxSize)) {
                                                if (onSizeExceeded) onSizeExceeded(e, fileObj, fileSizeBytes);
                                            } else {
                                                if (onFileLoading) onFileLoading(true);
                                                setShowLoader(true);
                                                const reader = new FileReader();
                                                reader.onload = () => {
                                                    const file = reader.result;
                                                    let fileName = (name + '').toLowerCase();
                                                    const acceptFormats = (accept + '').trim().toLowerCase().split(',')
                                                    if (checkNullStr(accept) && checkNullArr(acceptFormats, true)) {
                                                        //check-extensions
                                                        if (acceptFormats.some(format => fileName.endsWith((format + '').toLowerCase().trim()))) {
                                                            // if ()

                                                            setAvatarImg(file);
                                                            if (onChange) onChange(e, file, fileObj, name, fileExtension);
                                                            setErrorOccurred(false);
                                                        } else {
                                                            setDefAvatar(defAvatarImg);
                                                            setErrorOccurred(true);
                                                            // setAvatarImg(defAvatarImg);
                                                            if (onInvalidFormat) onInvalidFormat(e, name);
                                                        }
                                                    } else {
                                                        setAvatarImg(file);
                                                        if (onChange) onChange(e, file, fileObj, name, fileExtension);
                                                    }
                                                    setShowLoader(false);
                                                    if (onFileLoading) onFileLoading(false);
                                                    setDisableDrag(false);
                                                    setErrorOccurred(false);
                                                };
                                                reader.readAsDataURL(fileObj);
                                            }
                                        }
                                    } catch (error) {
                                        // console.error(error);
                                    }
                                }}
                        />}
                    </div>
                </Flexbox>
                {/*</div>*/}
            </div>}
        {canShowPreviewDialog() && createPreviewDialog()}
    </>)

    function createPreviewDialog() {
        return <Dialog
            open={openPreviewDialog}
            title={previewTitle}
            contentClassName={""}
            height={"auto"}
            maxHeight={"80vh"}
            widthClass={previewDialogWidthClass}
            className={"p-0 bg-transparent"}
            scrollVariant={"dark"}
            showHeader={false}
            showFooter={false}
            sleekControl={false}
            padded={false}
            scrolled={true}
            closeOnEscape={true}
            closeOnOutsideClick={true}
            showClose={true}
            closeClassName={`highlight-${THEME}-hover`}
            closeVariant={'dark'}
            onCancel={() => setOpenPreviewDialog(false)}
            onClose={() => setOpenPreviewDialog(false)}
            onConfirm={() => {
                setOpenPreviewDialog(false);
            }}>
            <div className={"w-100 m-0 p-0 d-flex jc-center al-center"}>
                <img
                    src={getDefStr(children, avatarImg)}
                    // wrapperClassName={'w-100 bg-danger d-flex jc-center al-center p-0 px-0'}
                    // src={avatarImg}
                    // src={children}
                    className={`object-fit-${previewObjectFit}`}
                    width={'100%'}
                    // height={'auto'}
                    height={vhToPx('80vh') + 'px'}
                    // objectFit={previewObjectFit}
                    // disableDrag={disableDrag}
                    alt={"Preview"}/>
            </div>
        </Dialog>
    }

    function canShowPreviewDialog() {
        // return (checkNullStr(children) && isBoolTrue(showFullPreviewDialog)) && !errorOccurred && (!showLoader && ((!checkNullStr(avatarImg, true) && (!showNameInitials)) || checkNullStr(avatarImg)));
        return checkNullStr(avatarImg) && isBoolTrue(showFullPreviewDialog) && !showLoader && !errorOccurred;
    }
}

Avatar.propTypes = {
    className: PropTypes.string,
    editClassName: PropTypes.string,
    wrapperClassName: PropTypes.string,
    imgClassName: PropTypes.string,
    editBg: PropTypes.string,
    id: PropTypes.string,
    buttonSize: PropTypes.string,
    size: PropTypes.string,
    children: PropTypes.node,
    wrapperStyle: PropTypes.object,
    style: PropTypes.object,
    editStyle: PropTypes.object,
    imgStyle: PropTypes.object,
    onChange: PropTypes.func,
    onInvalid: PropTypes.func,
    bordered: PropTypes.bool,
    showInitials: PropTypes.bool,
    circular: PropTypes.bool,
    hidden: PropTypes.bool,
    showEdit: PropTypes.bool,
    editTooltip: PropTypes.string,
    variant: PropTypes.string,
    nameForInitials: PropTypes.string,
    accept: PropTypes.any,
    // component: PropTypes.any,
    height: PropTypes.string,
    width: PropTypes.string,
    objectFit: PropTypes.string,
    hoverObjectFit: PropTypes.string,
    onImageClick: PropTypes.func,
    showObjectFitChangeControl: PropTypes.bool,
    changeObjectFitOnHover: PropTypes.bool,
    onObjectFitChange: PropTypes.func,
    showFullPreviewDialog: PropTypes.bool,
    previewBorder: PropTypes.bool,
    onFullPreview: PropTypes.func,
    onFullPreviewDialogClose: PropTypes.func,
    onFullPreviewDialogOpen: PropTypes.func,
    previewTitle: PropTypes.string,
    previewBorderVariant: PropTypes.string,
    capture: PropTypes.oneOf([true, false, undefined, "user", "environment"]),
}
export default Avatar;
